export default {
  'YouTube and High Definition Videos': 'YouTube und High Definition Videos',
  'Story videos (Instagram/Snaps/TikTok)': 'Geschichte Videos (Instagram/Snaps/TikTok)',
  'Facebook and Instagram Feed videos': 'Facebook und Instagram Feed Videos',
  'Facebook and Twitter Portrait Videos': 'Facebook und Twitter Porträtvideos',
  'Twitter and Facebbok Landscape Videos': 'Twitter und Facebook Landschaftsvideos',
  'Facebook Cover Videos And Blog Banners': 'Facebook Startseite Videos Und Blog Banners',
  'Fit': 'Passen',
  'Fill': 'Füllen',
}